import $ from 'jquery';
import { initAnalyticsInteractions, trackPromotionBannerImpression } from './analytics';
// slick is loaded from the CDN in _Layout <head> and registers on the global jQuery (which the bundle
// also uses via webpack externals) — bundling a second copy added 87KB for nothing.

type SlickCarouselInstance = {
    $slides?: JQuery;
    currentSlide?: number;
};

function trackSlidePromotion(slick: SlickCarouselInstance, slideIndex: number): void {
    const slide = slick.$slides?.eq(slideIndex);
    const item = slide?.find('.campaign-banner__item').get(0);
    trackPromotionBannerImpression(item);
}

export default function initCampaignBannerCarousel() {
    let delay: number;
    let useDots: boolean = true;

    let carouselElement = document.querySelector(`[data-component-part="campaign-banner-carousel"]`) as HTMLElement;
    if (carouselElement) {
        delay = parseInt(carouselElement.dataset.carouselDelay);
        useDots = Boolean(carouselElement.dataset.carouselUseDots).valueOf();
    }

    const $carousel = $('.campaign-banner-carousel');
    $carousel.on('init', (_event, slick) => {
        trackSlidePromotion(slick, slick.currentSlide ?? 0);
    });
    $carousel.on('afterChange', (_event, slick, currentSlide) => {
        trackSlidePromotion(slick, currentSlide);
    });

    $carousel.slick({
        dots: useDots,
        arrows: true,
        infinite: true,
        speed: 300,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplaySpeed: delay
    });

    initAnalyticsInteractions();
}
